<div class="paginator-container border">
  <ng-content select="[slot=aditional-data]"> </ng-content>
  <div class="d-flex flex-wrap align-items-center justify-content-center s-grow-3">
    <button mat-icon-button type="button" [disabled]="page === 1" (click)="paginate(1)">
      <mat-icon> first_page </mat-icon>
    </button>
    <button mat-icon-button type="button" [disabled]="page === 1" (click)="paginate(page - 1)">
      <mat-icon> navigate_before </mat-icon>
    </button>
    <div class="pagination-text">
      <input
        type="number"
        class="s-me-2 s-w-17"
        [(ngModel)]="inputPage"
        (keydown.enter)="paginate(inputPage)"
        min="1"
        [max]="totalPages"
      />
      de {{ totalPages }}
    </div>
    <button
      mat-icon-button
      type="button"
      [disabled]="page >= totalPages"
      (click)="paginate(page + 1)"
    >
      <mat-icon> navigate_next </mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      [disabled]="page >= totalPages"
      (click)="paginate(totalPages)"
    >
      <mat-icon> last_page </mat-icon>
    </button>
  </div>
  <div>
    <select class="form-select" [formControl]="paginationFormGroupRef().controls.pageSize">
      @for (item of paginationSizeList(); track $index) {
        <option [value]="item">
          {{ item }}
        </option>
      }
    </select>
  </div>
</div>
